import { OverlayContainer } from "@angular/cdk/overlay";
import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  RendererFactory2,
} from "@angular/core";
import { DateAdapter, MatIconRegistry } from "@angular/material";
import { DOCUMENT, DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { environment } from "../environments/environment";
import { ClientService } from "./core/client/client.service";
import { MensajeriaUsuarioService } from "./core/services/mensajeria-usuario.service";
import { DATE_LOCALE } from "./shared/constants/general.constants";

const TERMINACION_CLASES_TEMAS = "-theme";

export enum TemasVisualesEnum {
  Predeterminado,
  AltoContraste,
}

export interface TemaVisual {
  id: TemasVisualesEnum;
  i18n: string;
  claseTemaCSS: string;
}

@Component({
  selector: "i3jwt-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  private renderer: Renderer2;
  private claseTemaActual: string;

  constructor(
    private dateAdapter: DateAdapter<any>,
    private translate: TranslateService,
    private iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private mensajeriaService: MensajeriaUsuarioService,
    private clientService: ClientService,
    private rendererFactory: RendererFactory2,
    private overlayContainer: OverlayContainer,
    @Inject(DOCUMENT) private document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    this.dateAdapter.setLocale(DATE_LOCALE);

    // Cuando se cambie el idioma, se actualizarán los locales de Moment y del DateAdapter
    this.translate.onLangChange.subscribe((event) => {
      moment.locale(event.lang);
      this.dateAdapter.setLocale(event.lang);
    });

    this.translate.setDefaultLang(environment.defaultLang);
    this.translate.use(environment.defaultLang);

    this.iconRegistry.addSvgIcon(
      "gva",
      environment.appPath +
        sanitizer.bypassSecurityTrustResourceUrl(
          "assets/images/logo_gva_fff.svg"
        )
    );
  }

  ngOnInit() {
    // Si no se identifican los datos mínimos del cliente (realm y redirectUrl)
    // no se realiza redirección alguna y se muestra mensaje de error
    if (!this.clientService.getClient()) {
      this.mensajeriaService.notificarError(
        this.translate.instant("ERROR_HANDLER.CLIENT_IDENTITY_ERROR")
      );
    }

    this.establecerTemaVisual(TemasVisualesEnum.Predeterminado);
  }

  private establecerTemaVisual(temaVisual: TemasVisualesEnum) {
    const clasesOverlayContainer =
      this.overlayContainer.getContainerElement().classList;
    const clasesTemasAEliminar = Array.from(clasesOverlayContainer).filter(
      (clase: string) => clase.includes(TERMINACION_CLASES_TEMAS)
    );
    if (clasesTemasAEliminar) {
      clasesOverlayContainer.remove(...clasesTemasAEliminar);
    }
    const claseTemaVisual =
      this.obtenerTemasVisuales()[temaVisual].claseTemaCSS;
    clasesOverlayContainer.add(claseTemaVisual);
    if (this.claseTemaActual) {
      this.renderer.removeClass(this.document.body, this.claseTemaActual);
    }
    this.renderer.addClass(this.document.body, claseTemaVisual);
    this.claseTemaActual = claseTemaVisual;
  }

  private obtenerTemasVisuales(): TemaVisual[] {
    return [
      {
        id: TemasVisualesEnum.Predeterminado,
        i18n: "header.personalizar.temaColores.predeterminado",
        claseTemaCSS: "predeterminado-theme",
      },
      {
        id: TemasVisualesEnum.AltoContraste,
        i18n: "header.personalizar.temaColores.altoContraste",
        claseTemaCSS: "alto-contraste-theme",
      },
    ];
  }

  exit() {
    if (this.clientService.getClient()) {
      this.clientService.exit();
    } else {
      window.close();
    }
  }
}
